import * as types from '../action-types';
import { TextSelectionType } from '../../../utils/text-selection/textSelection.types';

export const storeSelectedText = (selectedText: string) =>
  <const>{
    type: types.storeSelectedText,
    payload: { selectedText },
  };

export const storeTextSelection = (textSelection: TextSelectionType | null) =>
  <const>{
    type: types.storeTextSelection,
    payload: { textSelection },
  };

export const storeSelectionId = (selectionId: number | null) =>
  <const>{
    type: types.storeSelectionId,
    payload: { selectionId },
  };

export type DecisionSelectionActions = ReturnType<
  typeof storeSelectedText | typeof storeTextSelection | typeof storeSelectionId
>;
